import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_37: FaireProductEntity = {
  token: "catalog_prod_prod-37",
  type: "product",
  name: "Decorative Item A - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 61.9,
  msrpDollars: 154.75,
  sku: "PA0037",
  caseSize: 2,
  material: "Cotton",
  collectionToken: "col_pattern-play",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: true,
  inStock: false,
  stockLevel: 1,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_mens-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
